import { AUTH_API_BASE } from "./AuthContext";

export async function postAuth(path, body) {
  const res = await fetch(`${AUTH_API_BASE}${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify(body),
  });

  const raw = await res.text();
  let data;
  try {
    data = JSON.parse(raw);
  } catch {
    throw new Error(
      res.ok
        ? "Password reset is unavailable. Please try again later."
        : "Request failed"
    );
  }

  if (!res.ok) {
    throw new Error(data?.message || "Request failed");
  }

  return data;
}
